export const RESET_USER_PROFILE_STATE = Symbol('auth/userProfile/RESET_USER_PROFILE_STATE');

export const GET_USER_PROFILE_LOADING = Symbol('auth/userProfile/GET_USER_PROFILE_LOADING');
export const GET_USER_PROFILE_SUCCESS = Symbol('auth/userProfile/GET_USER_PROFILE_SUCCESS');
export const GET_USER_PROFILE_FAILED = Symbol('auth/userProfile/GET_USER_PROFILE_FAILED');

export const DELETE_USER_PROFILE_LOADING = Symbol('auth/userProfile/DELETE_USER_PROFILE_LOADING');
export const DELETE_USER_PROFILE_SUCCESS = Symbol('auth/userProfile/DELETE_USER_PROFILE_SUCCESS');
export const DELETE_USER_PROFILE_FAILED = Symbol('auth/userProfile/DELETE_USER_PROFILE_FAILED');

export const UPDATE_USER_PASSWORD_LOADING = Symbol('auth/userProfile/UPDATE_USER_PASSWORD_LOADING');
export const UPDATE_USER_PASSWORD_SUCCESS = Symbol('auth/userProfile/UPDATE_USER_PASSWORD_SUCCESS');
export const UPDATE_USER_PASSWORD_FAILED = Symbol('auth/userProfile/UPDATE_USER_PASSWORD_FAILED');
export const RESET_UPDATE_USER_PASSWORD_STATE = Symbol(
    'auth/userProfile/RESET_UPDATE_USER_PASSWORD_STATE',
);

export const UPDATE_USER_ROLE_LOADING = Symbol('auth/userProfile/UPDATE_USER_ROLE_LOADING');
export const UPDATE_USER_ROLE_SUCCESS = Symbol('auth/userProfile/UPDATE_USER_ROLE_SUCCESS');
export const UPDATE_USER_ROLE_FAILED = Symbol('auth/userProfile/UPDATE_USER_ROLE_FAILED');

export const EDIT_USER_PROFILE_LOADING = Symbol('auth/userProfile/EDIT_USER_PROFILE_LOADING');
export const EDIT_USER_PROFILE_SUCCESS = Symbol('auth/userProfile/EDIT_USER_PROFILE_SUCCESS');
export const EDIT_USER_PROFILE_FAILED = Symbol('auth/userProfile/EDIT_USER_PROFILE_FAILED');
